const ROUTES = {
       LANDING: '/',
      ABOUT: '/about',
      PRIVACY_POLICY: '/privacy-policy',
      TERM_AND_CONDITION: '/term-and-condition',
      DOWNLOAD: '/download',
      ACCOUNT_DELETE: '/account-delete-request',
}
export default ROUTES;